import AssetDetailsPage from "@/pages/asset-details";
import type { RouteConfig } from "../models/types";

export const assetDetailsRoutes: RouteConfig[] = [
	{
		path: "/asset-details",
		element: <AssetDetailsPage />,
	},
	{
		path: "/asset-details/:AssetIdParam",
		element: <AssetDetailsPage />,
	},
];
